import { Button } from "@/components/ui/button";
import { useLocation } from "wouter";

interface StepperButtonsProps {
  onPrev?: () => void;
  onNext?: () => void;
}

export function StepperButtons({ onPrev, onNext }: StepperButtonsProps) {
  const [, setLocation] = useLocation();

  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row items-center gap-x-0.5">
        {onPrev && (
          <Button
            onClick={onPrev}
            variant="outline"
          >
            Back
          </Button>
        )}
        <Button
          variant="ghost"
          onClick={e => {
            e.preventDefault();
            setLocation("/plans");
          }}
        >
          Cancel
        </Button>
      </div>

      <div className="flex flex-row items-center gap-x-1">
        <Button
          variant="outline"
          onClick={e => e.preventDefault()}
        >
          Save as draft
        </Button>
        {onNext ? (
          <Button
            onClick={onNext}
          >
            Next
          </Button>
        ) : (
          <Button
            onClick={e => e.preventDefault()}
            disabled
          >
            Create plan
          </Button>
        )}
      </div>
    </div>
  );
}
